import React from 'react'

import {Icon} from '@vio/atlas/Icon'
import {Text} from '@vio/atlas/Text'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {StyledListItem} from '../commonStyles'
interface Props {
  onClick: () => void
}
export const EmailPreferences = ({onClick}: Props) => (
  <StyledListItem
    as="button"
    hasDivider
    onClick={onClick}
    prefix={<Icon name="Announcement" />}
    title={
      <Text variant="labelM">
        <FormattedMessageWrapper
          id="emailPreferences"
          defaultMessage="Email Preferences"
        />
      </Text>
    }
    suffix={<Icon name="ChevronRight" hasMirror />}
  />
)
